import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { StoryTimeline } from './components/StoryTimeline';
import { Skills } from './components/Skills';
import { Mission } from './components/Mission';
import { SocialProof } from './components/SocialProof';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="dark bg-[#0a0a0b] min-h-screen text-zinc-100 font-sans selection:bg-amber-500/30 selection:text-white overflow-x-hidden" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <StoryTimeline data-id="element-4" />
        <Skills data-id="element-5" />
        <Mission data-id="element-6" />
        <SocialProof data-id="element-7" />
        <FinalCTA data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}